/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface TrackItTaskResultForEvaluationDouble
 */
export interface TrackItTaskResultForEvaluationDouble {
    /**
     * 
     * @type {string}
     * @memberof TrackItTaskResultForEvaluationDouble
     */
    evaluationParameterId: string;
    /**
     * 
     * @type {number}
     * @memberof TrackItTaskResultForEvaluationDouble
     */
    value?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TrackItTaskResultForEvaluationDouble
     */
    $type?: TrackItTaskResultForEvaluationDoubleTypeEnum;
}


/**
 * @export
 */
export const TrackItTaskResultForEvaluationDoubleTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTrackItImportComponentDtoImportTrackItMeasurementDtoTrackItTaskResultForEvaluationDoublePtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.ImportTrackItMeasurementDto+TrackItTaskResultForEvaluationDouble, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type TrackItTaskResultForEvaluationDoubleTypeEnum = typeof TrackItTaskResultForEvaluationDoubleTypeEnum[keyof typeof TrackItTaskResultForEvaluationDoubleTypeEnum];



/**
 * Check if a given object implements the TrackItTaskResultForEvaluationDouble interface.
 */
export function instanceOfTrackItTaskResultForEvaluationDouble(value?: unknown): value is TrackItTaskResultForEvaluationDouble {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(TrackItTaskResultForEvaluationDoubleTypeEnum)[0];
}

export function TrackItTaskResultForEvaluationDoubleFromJSON(json: any): TrackItTaskResultForEvaluationDouble {
    return TrackItTaskResultForEvaluationDoubleFromJSONTyped(json, false);
}

export function TrackItTaskResultForEvaluationDoubleFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackItTaskResultForEvaluationDouble {
    if (json == null) {
        return json;
    }
    return {
        
        'evaluationParameterId': json['evaluationParameterId'],
        'value': json['value'] == null ? undefined : json['value'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function TrackItTaskResultForEvaluationDoubleToJSON(value?: TrackItTaskResultForEvaluationDouble | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'evaluationParameterId': value['evaluationParameterId'],
        'value': value['value'],
        '$type': value['$type'],
    });
}

